import React from "react";
import { Link } from "react-router-dom";
import { Phone, Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function StickyMobileCTA() {
  const { t } = useI18n();
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden flex gap-2 p-3 bg-white/95 backdrop-blur-md border-t border-slate-200"
      data-testid="sticky-mobile-cta"
    >
      <Link
        to="/plans"
        className="flex-1 nc-btn-primary justify-center"
        data-testid="sticky-get-plan-btn"
      >
        <Sparkles className="w-4 h-4" /> {t("cta.getPlan")}
      </Link>
      <Link
        to="/customize"
        className="flex-1 nc-btn-outline justify-center inline-flex items-center"
        data-testid="sticky-talk-expert-btn"
      >
        <Phone className="w-4 h-4 mr-1.5" /> {t("cta.talkExpert")}
      </Link>
    </div>
  );
}
